import React from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { StepFormField } from "../../Step.types";
import { sanitizeContent as s } from "../../../../util/functions";
import TextInput from "../TextInput";
import styles from './SelectDropdown.module.scss';
import block from 'bem-css-modules';

const ManualInput = (props: { manualDoctorInput: any; isManualInput: boolean, onStateChangeManualInput: (newState: boolean) => void, register: UseFormRegister<any>, errors: FieldErrors; }) => {
  const {
    manualDoctorInput,
    isManualInput,
    onStateChangeManualInput,
    register,
    errors,
  } = props;

  const { 
    aboveButtonText,
    buttonText,
    doctorFields,
  } = manualDoctorInput

  const handleOnClick = () => {
    onStateChangeManualInput(true);
  };

  const b = block(styles);

  return (
    <>
      {manualDoctorInput && 
          aboveButtonText && <p dangerouslySetInnerHTML={{ __html: s(aboveButtonText) }} style={{ marginTop: "2.5rem" }} />
        }
        {buttonText && (
          <div className={b("button")}>
            <button type="button" onClick={handleOnClick} disabled={isManualInput} >
              <span dangerouslySetInnerHTML={{ __html: s(buttonText) }} />
            </button>
          </div>
        )}
        {isManualInput && (
          <div style={{ marginTop: "2.5rem" }}>
            {}
            {doctorFields?.map((field: StepFormField, i: number) => {
              return <TextInput key={i} fieldData={field} register={register} errors={errors} />
            })}
          </div>
        )}
    </>
  );
};

export default ManualInput;
